import { EDIT_PROGRAM_CAP } from "../constants/caps"
import hasCap from "./hasCap"

const canEditProgram = caps => hasCap(caps, EDIT_PROGRAM_CAP)

export default canEditProgram